import type { FilterDef, FilterState } from './types.js';

export function filterRows<T>(
    rows: T[],
    filters: Array<FilterDef<T>>,
    filterState: FilterState,
): T[] {
    return rows.filter((row) => {
        for (const f of filters) {
            const val = filterState[f.key] ?? '';
            if (!val) continue;
            const cellVal = f.accessor(row);
            if (f.type === 'text') {
                if (
                    !String(cellVal ?? '')
                        .toUpperCase()
                        .includes(val.toUpperCase())
                )
                    return false;
            } else if (f.type === 'min') {
                const num = parseFloat(val);
                if (!isNaN(num) && ((cellVal as number) ?? 0) < num) return false;
            } else if (f.type === 'max') {
                const num = parseFloat(val);
                if (!isNaN(num) && ((cellVal as number) ?? 0) > num) return false;
            } else if (f.type === 'date-from') {
                if (cellVal != null && String(cellVal) < val) return false;
            } else if (f.type === 'select') {
                if (String(cellVal ?? '').toUpperCase() !== val.toUpperCase()) return false;
            } else if (f.type === 'multiselect') {
                const selected = val.split(',').map((s) => s.toUpperCase());
                // cellVal may itself be a comma-joined list (e.g. a row with multiple
                // simultaneous flags) -- match if any selected option is present, not just
                // an exact whole-value match, so multi-value cells behave like a proper OR.
                const cellValues = String(cellVal ?? '')
                    .split(',')
                    .map((s) => s.toUpperCase());
                if (!selected.some((s) => cellValues.includes(s))) return false;
            }
        }
        return true;
    });
}
